package uz.ferro.shop.pages.about

import mui.material.Box
import mui.system.sx
import react.FC
import react.Props
import react.useContext
import uz.ferro.shop.AppContext
import uz.ferro.shop.Colors
import uz.ferro.shop.ui.AppTextMedium
import uz.ferro.shop.ui.HorizontalLayout
import uz.ferro.shop.ui.StackLayout
import uz.ferro.shop.ui.VerticalLayout
import uz.ferro.shop.util.localizedOrDefault
import uz.ferro.shop.util.styleInMobile
import uz.ferro.shop.util.twoDigitAtLeast
import web.cssom.AlignItems
import web.cssom.Display
import web.cssom.FontWeight
import web.cssom.JustifyContent
import web.cssom.LineStyle
import web.cssom.Position
import web.cssom.integer
import web.cssom.number
import web.cssom.px

external interface AboutDataProps : Props {
    var data: AboutPageData
}

val AboutMissionsAndStrategy = FC<AboutDataProps> { props ->
    val data = props.data
    val appContext = useContext(AppContext)
    val isMobile = appContext.isMd.not()

    StackLayout {
        isHorizontal = isMobile.not()
        space = 20.px

        sx {
            alignItems = AlignItems.stretch
        }

        VerticalLayout {
            sx {
                backgroundColor = Colors.accentColor
                padding = styleInMobile(12.px, 24.px)
                flexGrow = number(1.0)
                flexBasis = 0.px
            }

            AppTextMedium {
                sx {
                    fontSize = styleInMobile(18.px, 31.px)
                }
                color = Colors.accentContrastColor
                text = data?.mission?.title.localizedOrDefault()
            }

            Box {
                sx {
                    borderBottomWidth = 1.px
                    borderBottomColor = Colors.accentContrastColor
                    borderBottomStyle = LineStyle.solid
                    marginTop = styleInMobile(12.px, 24.px)
                }
            }

            AppTextMedium {
                sx {
                    marginTop = styleInMobile(12.px, 24.px)
                    fontSize = styleInMobile(13.px, 20.px)
                }
                color = Colors.accentContrastColor
                text = data?.mission?.description.localizedOrDefault()
            }
        }

        VerticalLayout {
            sx {
                backgroundColor = Colors.accentColor
                padding = styleInMobile(12.px, 24.px)
                flexGrow = number(1.0)
                flexBasis = 0.px
            }

            AppTextMedium {
                sx {
                    fontSize = styleInMobile(18.px, 31.px)
                }
                color = Colors.accentContrastColor
                text = data?.strategy?.title.localizedOrDefault()
            }

            Box {
                sx {
                    borderBottomWidth = 1.px
                    borderBottomColor = Colors.accentContrastColor
                    borderBottomStyle = LineStyle.solid
                    marginTop = styleInMobile(12.px, 24.px)
                }
            }

            AppTextMedium {
                sx {
                    marginTop = styleInMobile(12.px, 24.px)
                    fontSize = styleInMobile(13.px, 20.px)
                }
                color = Colors.accentContrastColor
                text = data?.strategy?.description.localizedOrDefault()
            }

            HorizontalLayout {
                space = 30.px
                sx {
                    marginTop = 24.px
                }
                data?.strategy?.items?.forEachIndexed { index, item ->
                    Box {
                        sx {
                            flexGrow = number(1.0)
                            flexBasis = 0.px
                            position = Position.relative
                        }

                        VerticalLayout {
                            sx {
                                backgroundColor = Colors.yellow
                                borderRadius = styleInMobile(15.px, 30.px)
                                height = styleInMobile(30.px, 60.px)
                                alignItems = AlignItems.center
                                justifyContent = JustifyContent.center
                                fontWeight = FontWeight.bold
                                fontSize = styleInMobile(13.px, 20.px)
                                marginTop = styleInMobile(10.px, 12.px)
                            }
                            +item.title.localizedOrDefault()
                        }

                        VerticalLayout {
                            sx {
                                display = Display.inline
                                backgroundColor = Colors.black
                                borderRadius = styleInMobile(10.px, 12.px)
                                height = styleInMobile(20.px, 24.px)
                                alignItems = AlignItems.center
                                fontSize = styleInMobile(11.px, 16.px)
                                justifyContent = JustifyContent.center
                                paddingLeft = 6.px
                                paddingRight = 6.px
                                paddingTop = styleInMobile(3.px, 3.px)
                                paddingBottom = styleInMobile(3.px, 3.px)
                                fontWeight = integer(500)
                                color = Colors.white
                                position = Position.absolute
                                left = styleInMobile(10.px, 20.px)
                                top = 0.px
                            }

                            +(index + 1).twoDigitAtLeast()
                        }
                    }
                }
            }
        }


        VerticalLayout {
            sx {
                backgroundColor = Colors.accentColor
                padding = styleInMobile(12.px, 24.px)
                flexGrow = number(1.0)
                flexBasis = 0.px
            }

            AppTextMedium {
                sx {
                    fontSize = styleInMobile(18.px, 31.px)
                }
                color = Colors.accentContrastColor
                text = data?.companyValues?.title.localizedOrDefault()
            }

            Box {
                sx {
                    borderBottomWidth = 1.px
                    borderBottomColor = Colors.accentContrastColor
                    borderBottomStyle = LineStyle.solid
                    marginTop = styleInMobile(12.px, 24.px)
                }
            }

            VerticalLayout {
                sx {
                    marginTop = styleInMobile(12.px, 16.px)
                }
                space = styleInMobile(12.px, 16.px)

                data.companyValues.items?.forEachIndexed { index, item ->
                    HorizontalLayout {
                        space = styleInMobile(8.px, 12.px)

                        VerticalLayout {
                            sx {
                                width = styleInMobile(20.px, 36.px)
                                height = styleInMobile(20.px, 36.px)
                                backgroundColor = Colors.yellow
                                borderRadius = styleInMobile(10.px, 18.px)
                                fontWeight = FontWeight.bold
                                flexShrink = number(0.0)
                                color = Colors.black
                                alignItems = AlignItems.center
                                justifyContent = JustifyContent.center
                                fontSize = styleInMobile(13.px, 20.px)
                            }
                            +(index + 1).toString()
                        }

                        AppTextMedium {
                            color = Colors.white
                            text = item.title.localizedOrDefault()
                            sx {
                                fontSize = styleInMobile(13.px, 20.px)
                                paddingTop = styleInMobile(2.px, 6.px)
                            }
                        }
                    }
                }
            }
        }
    }
}